// custom.js

// Popup: fade in after 3 seconds, once per session
window.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('.popup');
  if (!popup) return;

  if (sessionStorage.getItem('popupSeen')) return;

  setTimeout(function () {
    popup.classList.add('is-visible');
    sessionStorage.setItem('popupSeen', '1');
  }, 3000);

  const closeBtn = popup.querySelector('.popup__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      popup.classList.remove('is-visible');
    });
  }
});
const dayAbbr = ['SUN', 'MON', 'TUES', 'WED', 'THURS', 'FRI', 'SAT'];
const monthAbbr = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

function formatEventDate(datetime) {
  const d = new Date(datetime);
  return dayAbbr[d.getDay()] + ', ' + monthAbbr[d.getMonth()] + ' ' + d.getDate();
}

// tour
fetch('https://rest.bandsintown.com/artists/sara%20bareilles/events?app_id=45PRESS_SARA_BAREILLES')
  .then(res => res.json())
  .then(data => {
    const events = document.getElementById('events');
    if (!events) return;
    let html = '';
    if (data.length) {
      for (let event of data) {
        let location = event.venue.city + ', ' + event.venue.region;
        if (location === ', ') { location = ''; }
        if (event.venue.name.toLowerCase() === 'streaming live') { location = 'Online'; }

        html += '<div class="event">';

          html += '<div class="event-date">' + formatEventDate(event.datetime) + '</div>';
          
          html += '<div class="event-location">' + event.venue.location + '</div>';

          html += '<div class="event-venue">' + event.venue.name + '</div>';

          html += '<div class="event-buttons">';
            if (event.offers[0]) {
              html += '<a href="' + event.offers[0].url + '" target="_blank" class="button">' + event.offers[0].type + '</a>';
            }
            if (event.offers[1]) {
              html += '<a href="' + event.offers[1].url + '" target="_blank" class="button">' + event.offers[1].type + '</a>';
            }
          html += '</div>';

        html += '</div>';
      }
      events.innerHTML = html;
    } else {
      events.innerHTML = 'No upcoming events.';
    }
  })
  .catch(() => {
    alert('Error fetching events!');
  });
